import React from 'react';
import { Box, Chip, Link, Typography } from '@mui/material';
import moment from 'moment';
import { renderStatus } from '../../../components/v2/cell-renderers/status';
import { getStatusLabel } from './constants';

export const cellContentSx = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  minWidth: 0,
  width: '100%',
  py: 0.5,
};

const formatDate = (value) => {
  if (value == null) return '—';
  return moment(value).format('DD/MM/YYYY');
};

const nsirLinkSx = {
  color: 'info.main',
  fontWeight: 600,
  textDecoration: 'underline',
  '&:hover': { color: 'info.dark' },
};

export const renderNsirCodigo = (row) => {
  const { id, codigo } = row;
  if (!codigo) return '—';
  if (!id) return codigo;
  const href = `${window.location.origin}/nsir/${id}`;
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      sx={nsirLinkSx}
    >
      {codigo}
    </Link>
  );
};

export const renderEquipamentoCol = (row) => (
  <Box sx={cellContentSx}>
    <Typography variant="body2" noWrap>
      <Box component="span" sx={{ fontWeight: 700 }}>NSIR: </Box>
      {renderNsirCodigo(row)}
    </Typography>
    {row.equipamento && (
      <Typography variant="body2" noWrap>
        <Box component="span" sx={{ fontWeight: 700 }}>Equip.: </Box>
        {row.equipamento}
      </Typography>
    )}
    {row.possuiAdere && row.adereMonth && (
      <Chip
        label={`Adere ${row.adereMonth}`}
        size="small"
        sx={{ mt: 0.5, alignSelf: 'flex-start', fontWeight: 600 }}
      />
    )}
  </Box>
);

export const renderStatusCol = (row) => (
  <Box sx={cellContentSx}>
    {row.status
      ? renderStatus({
          value: row.status,
          label: row.statusName || getStatusLabel(row.status) || row.status,
        })
      : '—'}
  </Box>
);

export const renderMalhaCol = (row) => (
  <Box sx={cellContentSx}>
    <Typography variant="body2" noWrap>
      <Box component="span" sx={{ fontWeight: 700 }}>Malha: </Box>
      {row.malha || row.malhaNome || '—'}
    </Typography>
    <Typography variant="body2" noWrap>
      <Box component="span" sx={{ fontWeight: 700 }}>Gerência: </Box>
      {row.gerencia || row.gerenciaNome || '—'}
    </Typography>
  </Box>
);

export const renderDatasCol = (row) => (
  <Box sx={cellContentSx}>
    <Typography variant="body2">
      <Box component="span" sx={{ fontWeight: 700 }}>Inspeção: </Box>
      {formatDate(row.dataInspecao)}
    </Typography>
    <Typography variant="body2">
      <Box component="span" sx={{ fontWeight: 700 }}>Vencimento: </Box>
      {formatDate(row.vencimento)}
    </Typography>
  </Box>
);
